import React, { ReactElement, useContext, useState } from 'react'
import uuid from 'uuid-random'

import IconButton, { IconButtonType } from '../../Common/Components/IconButton'
import { IconName } from '../../Common/Components/Icon'

import ConfigureReport from '../../ConfigureReport'

import { LanguageContext } from '../../Common/Contexts'

import { ConfigureReport as ConfigureReportLanguage, LanguageMainMenu } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'

/**
 * Component properties type.
 */
type Props = {
    refreshReportListDataAndStartReport: (reportID: string, reportDesc: string) => void | Promise<void>
    addReport: () => void
}

/**
 * Add report button and modal with configuration of new report.
 * @param refreshReportListDataAndStartReport Callback method to reload report list data and start report with provided ID.
 * @param addReport Easter egg handler used to open old configuration window.
 */
const AddReportButton: React.FC<Props> = ({ refreshReportListDataAndStartReport, addReport }: Props): ReactElement => {
    const language = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle('LanguageMainMenu')
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

    const handleAddButtonClick = (e?: React.MouseEvent): void => {
        e?.preventDefault()
        if (e?.shiftKey && e?.altKey) {
            // Easter egg with old configuration window.
            addReport()
        } else {
            setIsModalOpen(true)
        }
    }

    return (
        <div className='hidden-visibility'>
            <IconButton
                customClassName='add-report-button'
                iconName={IconName.ADD}
                title={language.get(LanguageMainMenu.MainmenuButtonTitleAddreport)}
                type={IconButtonType.BUTTON}
                isEnabled={true}
                onClick={handleAddButtonClick}
            />
            <ConfigureReport
                uuid={uuid()}
                modalTitle={language.get(ConfigureReportLanguage.ModalTitleAdd)}
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                refreshReportListDataAndStartReport={refreshReportListDataAndStartReport}
            />
        </div>
    )
}

export default AddReportButton
